LS.util.route({
	'account': {
		'$guard:eval': {
			'password': {
				':load': 'account.password',
				':unload': 'account.password:unload'
			},
			'notifications': {
				':load': 'account.notifications',
				':unload': 'account.notifications:unload'
			},
			'hidden': {
				'$any:preload:once': () => {
					LS.util.load('account-hidden');
				}
			},
			'listings': {
				'$any:preload:once': () => {
					LS.util.load('account-listings');
				}
			},
			'messages': {
				'$any:preload:once': () => {
					LS.util.load('account-messages');
				}
			},
			'calls': {
				'$any:preload:once': () => {
					LS.util.load('account-calls');
				}
			},
			'profile||profiles': {
				'$any:preload:once': () => {
					LS.util.load('account-profile');
				}
			},
			'saves': {
				'$any:preload:once': () => {
					LS.util.load('account-saves');
				}
			},
			'searches': {
				'$any:preload:once': () => {
					LS.util.load('account-searches');
				}
			},
			'teams': {
				'$any:preload:once': () => {
					LS.util.load('account-teams');
				}
			},
			'views': {
				'$any:preload:once': () => {
					LS.util.load('account-views');
				}
			}
		}
	}
});